// extracted by mini-css-extract-plugin
export default {"imageInfo":"ImageInfo_imageInfo__Y2Y2M","credit":"ImageInfo_credit__MjJkM","creditIcon":"ImageInfo_creditIcon__YjJkY"};